export { GTMProvider } from './ui/GTMProvider';
export { GTMInitializer } from './ui/GTMInitializer';
export { useGTM } from './model/hooks/useGTM';
export { PageType } from './model/enums';
export type { GAEventParams } from './utils/trackEvent';
